import { render, staticRenderFns } from "./Impresion.vue?vue&type=template&id=02650733"
import script from "./Impresion.vue?vue&type=script&lang=js"
export * from "./Impresion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports